import { fs16 } from "../../../tools";

const styles = {
  itemText: {
    ...fs16,
    color: "#5B6378",
    lineHeight: "24px",
  },
};

export { styles };
